<template>
  <el-dialog
    title="角色授权"
    :visible.sync="dialogVisible"
    width="400"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close">
    <el-row type="flex" style="margin-bottom: 10px">
      <p class="label">角色名称: </p>
      <p class="value">{{ roleName }}</p>
    </el-row>
    <el-switch
      v-model="totalStatus"
      active-text="全部展示"
      inactive-text="全部隐藏"
      :active-value="1"
      :inactive-value="2"
      @change="handleToggaleAllStatus"
    ></el-switch>
    <el-table border v-loading="loading" :data="data" max-height="508px" style="width:100%;margin-top:10px">
      <el-table-column label="租户名称" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.companyName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否展示" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.status"
              :active-value="1"
              :inactive-value="2"
              @change="handleToggaleStatus($event, row)"
            />
          </template>
        </el-table-column>
    </el-table>
    <span slot="footer" />
  </el-dialog>
</template>

<script>
import { getRoleAuthInfoList, updateAllStatus, updateStatus } from "@/api/organization";

export default {

  data () {
    return {
      dialogVisible: false,
      roleId: '',
      roleName: '',
      totalStatus: 2,
      loading: false,
      data: []
    };
  },
  methods: {
    // 全部状态
    handleToggaleAllStatus (status) {
      const params = {
        roleId: this.roleId,
        status: status
      }
      console.log(params)

      updateAllStatus(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('批量操作成功!')
          this.getList()
        }
      })
    },
    handleToggaleStatus (status, row) {
      const params = {
        roleId: this.roleId,
        status: status,
        companyId: row.companyId
      }
      updateStatus(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('操作成功!')
          this.getList()
        }
      })
    },
    async getList () {
      this.loading = true
      const res = await getRoleAuthInfoList({ roleId: this.roleId })
      if (res.code !== 0) return this.$message.error(res.message)
      this.data = res.data
      this.totalStatus = res.data.every(item => item.status === 1) ? 1 : 2
      this.loading = false
    },
    init(row) {
      this.roleId = row.roleId
      this.roleName = row.roleName
      this.getList()
      this.dialogVisible = true
    },
    close() {
      this.roleId = ''
      this.roleName = ''
      this.data = []
      this.dialogVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  margin-right: 8px;
}
</style>
